import React from "react";
import { observer, inject } from 'mobx-react';

import GridOnIcon from '@material-ui/icons/GridOn';
import { Popover as MUIPopover, Typography, Table, TableHead, TableBody, TableRow, TableCell, Button, Grid, CircularProgress, TextField, Link } from "@material-ui/core";
import ExtjsViewAggregationPanel from "./components/ExtjsViewAggregationPanel";
import ColumnOptions from "./components/ColumnOptions";
import LimitGroupBy from "./components/LimitGroupBy";
import VirtualizedTable from "./components/VirtualizedTable";
import SelectMultiLevel from "../common/components/input/Menu/SelectMultiLevel"
import styled, { css } from "styled-components";
import { FaTh } from "react-icons/fa";
import COLORS from "scss/colors.module.scss";

class ViewAggregationPopup extends React.Component {

    constructor(props) {
        super(props);

        this.baseGrid = Ext.create("TL.list.BaseGrid")
    }

    componentDidUpdate() {
        this.props.store.isExtjsDelayedRender = false;
    }

    render() {
        let me = this,
            store = this.props.store,
            columns;

        columns = store.tableColumns;
        if (columns.length != 0) {
            columns = [
                {
                    Header: 'Sr. No.',
                    accessor: 'SR_NO',
                    width: 100,
                    Cell: (row) => {
                        return <div>{row.row.index + 1}</div>;
                    }
                },
                ...columns
            ]

        }

        return (
            <div>
                {
                //     <GridOnIcon
                //     className={"view_aggregation_popup_icon" + (Util.isMainDashboard() ? " main_dashboard" : "")}
                //     aria-haspopup="true"
                //     onClick={store.handleClick}
                // />
            }
                <StyledAnalayticsDiv
                    className="d-flex"
                    onClick={() => {
                        this.props.handleClose();
                        store.handleClick();
                    }}
                >
                    <IconWrapper>
                        <FaTh
                            size={18}
                            color={COLORS.TEXT_COLOR}
                        />
                    </IconWrapper>
                    Analaytics
                </StyledAnalayticsDiv>
                <Popover
                    open={Boolean(store.anchorEl)}
                    anchorEl={store.anchorEl}
                    onClose={store.handleClose}
                    disableEnforceFocus // issue fix with extjs input boxes focus. 
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    PaperProps={
                        {
                            className: "view_aggregation_popup",
                        }
                    }
                    counterForWidthCheck={store.data.length + columns.length}
                >

                    {
                        store.viewAggregationColumns.map((value, key) => {
                            return (<Grid item container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                spacing={1}
                                key={value.unique_dom_id}
                            // key={value.aggregation_type + "_" + value.alias_path} // todo fix this. this rerenders every time, required for extjs component
                            >
                                <Grid item  >
                                    <ExtjsViewAggregationPanel
                                        config={store.listConfig}
                                        viewConfig={store.viewConfig}
                                        columns={store.columns}
                                        // style={{ width: 1000 }}
                                        onChange={(column) => store.handleViewAggregationColumnChange(column, key)}
                                        onColumnValueChange={(value) => store.handleViewAggregationColumnValueChange(value, key)}
                                        aggregationType={value.aggregation_type}
                                        aggregationColumn={value}
                                        shouldFetchCount={true}
                                        delayedRender={store.isExtjsDelayedRender}
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2" className={"aggregation_value" + (value.is_loading ? " mask" : "")} >
                                        {value.aggregation_value || 0}
                                    </Typography>
                                </Grid>
                                {
                                    value.aggregation_type == "count" && <Grid item>
                                        <Typography className="records_text" variant="body2">
                                            records
                                        </Typography>
                                    </Grid>
                                }

                                <Grid item
                                    style={{
                                        width: 70
                                    }}
                                >
                                    {<Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => store.handleDeleteViewAggregationColumn(key)}
                                    >
                                        -
                                </Button>
                                    }
                                </Grid>

                                {
                                    store.viewAggregationColumns.length == (key + 1) &&
                                    <Grid item style={{
                                        marginLeft: 18
                                    }}

                                        style={{
                                            width: 70
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={store.handleAddViewAggregationColumn}
                                        >
                                            +
                                </Button> </Grid>
                                }
                            </Grid>)
                        })
                    }

                    <Typography variant="h6">Summarize by </Typography>

                    {
                        store.groupByColumns.map((value, key) => {

                            return (<Grid item container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                                spacing={1}
                                style={{ paddingTop: 10 }}
                                key={key}
                            >
                                <Grid item >
                                    <SelectMultiLevel
                                        displayKey={"name"}
                                        className="select_multilevel"
                                        values={store.columns}
                                        valueKey={"alias_path"}
                                        value={value}
                                        label={"column"}
                                        // labelPosition={"inline"}
                                        onChange={(val) => { store.handleGroupByColumnChange(val, key) }}
                                    // onChange={(col) => onChange(col)}
                                    />
                                    {/* <SelectCustom
                                        className="gray_dropdown"
                                        // value={value}
                                        valueKey={'alias_path'}
                                        labelPosition="inline"
                                        label="column"
                                        value={value}
                                        values={store.columns}
                                        onChange={(val) => { store.handleGroupByColumnChange(val, key) }}
                                    /> */}
                                </Grid>
                                <Grid item >
                                    <ColumnOptions column={value} onChange={(val) => { store.handleGroupByColumnOptionsChange(val, key) }} />
                                </Grid>
                                {key == 0 && value.alias_path &&
                                    <Grid item >
                                        <LimitGroupBy
                                            value={value.group_by_options && value.group_by_options.limit ? value.group_by_options.limit : ""}
                                            onChange={(val) => { store.handleGroupByColumnLimitChange(val, key) }}
                                            totalCount={store.totalCount}
                                        />
                                    </Grid>
                                }

                                <Grid item
                                    style={{
                                        width: 70
                                    }}
                                >
                                    {<Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => store.handleGroupByColumnDelete(key)}
                                    >
                                        -
                                </Button>
                                    }
                                </Grid>

                                {store.groupByColumns.length == (key + 1) &&
                                    <Grid item style={{
                                        marginLeft: 18
                                    }}

                                        style={{
                                            width: 70
                                        }}
                                    >
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={store.handleAddButtonClick}
                                        >
                                            +
                                </Button> </Grid>}
                            </Grid>)
                        })
                    }


                    {store.isLoading && <CircularProgress style={{ marginTop: 20 }} />}
                    {/* {store.data.length > 0 && <ReactTable columns={columns} data={store.data} style={{ marginTop: 20 }} />} */}
                    {store.data.length > 0 &&
                        <VirtualizedTable columns={columns} data={store.data} style={{ marginTop: 20, maxWidth: "100%", overflow: "auto" }} onCellClick={(column, value) => {
                            let criteria = store.getCriteria(column, value);

                            //this.props.listeners.onViewCriteriaChange(criteria);
                            store.handleClose();
                        }} />
                    }

                </Popover>
            </div >
        );
    }
}

export default inject('store')(observer(ViewAggregationPopup));

function Popover({ counterForWidthCheck, children, ...others }) {
    const popoverRef = React.useRef();

    React.useEffect(() => {
        if (popoverRef.current) {
            let popover = popoverRef.current.children[2],
                popoverWidth = popover.offsetWidth,
                left = popover.offsetLeft,
                bodyWidth = document.body.offsetWidth;

            if (left + popoverWidth > bodyWidth) {
                window.dispatchEvent(new CustomEvent('resize'))
            }
        }
    }, [counterForWidthCheck]);

    return <MUIPopover innerRef={popoverRef} {...others}>{children}</MUIPopover>;
}

const StyledAnalayticsDiv = styled.div`
  cursor: pointer;
  padding: 6px 16px;
  align-items: center;
  line-height: 20px;
  white-space: nowrap;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

const IconWrapper = styled.div`
  margin-right: 15px;
`;